/**
 * Empty Studio `normal` blocks render as this marker instead of an empty
 * paragraph.
 *
 * Kept as a plain `<br>` so prose-mode RichText matches historical empty-block
 * spacing. When the parent uses `RICH_TEXT_CONTAINER_WIDTH_GRID_CLASS`,
 * direct-child gaps get an explicit block size via `[&>[data-rich-text-gap]]`
 * utilities — a bare `<br>` collapses as a CSS grid item.
 */
function RichTextGap() {
  return <br aria-hidden="true" data-rich-text-gap />;
}

export { RichTextGap };
